import Vue from 'vue';
import Vuex from 'vuex';
import socketObj from '@/utils/socket/socket_methods.js';
import { actionType, messageType } from '@/utils/socket/socket_constant';
import { get, post } from '@/utils/request';
import CircularJSON from 'circular-json';

Vue.use(Vuex)
export default {
    namespaced: true,
    // 定义数据
    state: {
        isSocketOpened: false, //WebSocket是否打开
        isManualClose: false, // 是否手动关闭socket
        socketTask: null,// websocket实例
        heartbeatInterval: null, // 心跳定时器
        websocketUrl: null,// websocket地址
        onReceiveEventFun: null,// 消息接收回调函数
        onErrorEventFun: null,// 错误回调函数
        onSucceedEventFun: null,// 成功回调函数
        userInfo:[],// 登陆用户数据


        chatList: [],// 用户列表
        chatUserInfo: {},// 当前聊天用户
        chatListss: {},// 当前用户新消息
        unChat: {}, // 发送信息前缓存禁言
        Mute: false,// 是否禁言
        loggedIn: false,// 是否在其他地方登陆
        isNetworkError: false,// 网络是否异常
        router: '',// 路由实例
        onlines: false,// 是否查询状态
        resetOnLine: 0,// 是否重置连接
        heartbeatInterval2: '',// 在线定时器
        protectThread: false,// 保护线程
        onLineMessageIds: [], // 离线消息id
        onLineIds: [],// 页面显示id
    },
    // 操作数据
    mutations: {
        // 设置WebSocket是否打开
        setIsSocketOpened(state,isSocketOpened){
            state.isSocketOpened = isSocketOpened;
        },
        // 设置在线定时
        setHeartbeatInterval2(state,heartbeatInterval2){
            state.heartbeatInterval2= heartbeatInterval2;
        },
        // 设置WebSocket实列
        setSocketTask(state,socketTask){
            state.socketTask = socketTask;
        },
        // 设置是否手动关闭socket
        setIsManualClose(state,isManualClose){
            state.isManualClose = isManualClose;
        },
        // 设置心跳计数器
        setHeartbeatInterval(state,heartbeatInterval){
            state.heartbeatInterval = heartbeatInterval;
        },
        // 设置websocket地址 
        setSocketUrl(state,websocketUrl){
            // console.log(websocketUrl)
            state.websocketUrl = websocketUrl;
        },
        // 设置消息接收回调函数
        setOnReceiveEventFun(state,onReceiveEventFun){
            // console.log(onReceiveEventFun,'onReceiveEventFun')
            state.onReceiveEventFun = onReceiveEventFun;
        },
        // 设置错误回调函数
        setOnErrorEventFun(state,onErrorEventFun){
            state.onErrorEventFun = onErrorEventFun;
        },
        // 设置成功回调函数
        setOnSucceedEventFun(state,onSucceedEventFun){
            state.onSucceedEventFun = onSucceedEventFun;
        },
        // 设置用户信息
        setUserInfos(state,userInfo){
            state.userInfo = userInfo;
        },
        // 设置用户列表
        setChatList(state,chatList){
            state.chatList = chatList;
            // console.log(state.chatList,'wojso1')
        },
        // 设置当前聊天用户
        setChatUserInfo(state,chatUserInfo){
            if(JSON.stringify(chatUserInfo) != '{}'){
                let mo = JSON.parse(JSON.stringify(chatUserInfo))
                let mo1 = JSON.parse(JSON.stringify(state.chatUserInfo))
                delete mo.lastMessage;
                delete mo.lastMessageTime;
                delete mo.unReadNums;
                delete mo1.lastMessage;
                delete mo1.lastMessageTime;
                delete mo1.unReadNums;
                if(JSON.stringify(mo1) === JSON.stringify(mo)){
                    return
                }
                for(let i = 0;i<=state.chatList.length;i++){
                    if(state.chatList[i].senderId == chatUserInfo.senderId){
                        state.chatList[i].unReadNums = 0
                        break;
                    }
                }
                state.Mute = false;
                state.chatUserInfo = chatUserInfo;
                localStorage.setItem(`chatList_${state.userInfo.id}`,JSON.stringify(state.chatList))
            }else{
                state.chatUserInfo = {}
            }
        },
        // 设置当前聊天记录
        setChatListss(state,chatListss){
            // console.log(chatListss)
            state.chatListss = chatListss;
        },
        // 设置删除某一个用户列表
        deleteChatList(state,id){
            let arr = state.chatList
            arr = arr.filter(item => item.senderId !== id)
            state.chatList = arr;
            state.chatUserInfo = {};
            localStorage.setItem(`chatList_${state.userInfo.id}`,JSON.stringify(arr))
            if(state.chatUserInfo.senderId == id){
                state.chatUserInfo = {}
                state.setChatListss = "ChatUserInfoOfDelete"
            }
        },
        // 设置禁言
        setUnChat(state,unChat){
            state.unChat = unChat;
        },
        // 发信息列表上移
        setChatListssMove(state,chatListss){
            if(!chatListss.receiver){
                return;
            }
            // console.log(chatListss,'处理我发的信息列表');
            let list = JSON.parse(localStorage.getItem(`chatList_${state.userInfo.id}`))
            for (const key in state.chatList) {
                if(state.chatList[key].senderId == chatListss.receiver.id){
                    // 先复制一份数据
                    let list_copy = state.chatList[key];
                    list_copy.lastMessageTime = chatListss.createTime;
                    list_copy.lastMessage = chatListss.messageType == 2 ? '[图片]' : chatListss.messageContent;
                    list.splice(key, 1)
                    // 把消息放在最前面
                    list.unshift(list_copy)
                    localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list));
                    state.chatList = list;
                    // that.chatList = uni.getStorageSync('chatList')
                    break;
                }
            }
        },
        // 设置是否禁言
        setMute(state,Mute){
            state.Mute = Mute;
        },
        // 设置是否在其他地方登陆
        setIsLoggedIn(state,isLoggedIn){
            state.loggedIn = isLoggedIn;
        },
        // 设置网络是否异常
        setIsNetworkError(state, isNetworkError){
            state.isNetworkError = isNetworkError;
        },
        // 设置路由实例
        setRouter(state,router){
            state.router = router;
        },
        // 设置查询状态
        SetOnlines(state,onlines){
            state.onlines = onlines;
        },
        // 设置重置次数
        SetResetOnLine(state,resetOnLine){
            state.resetOnLine = resetOnLine;
        },
        // 设置保护线程
        setProtectThread(state,protectThread){
            state.protectThread = protectThread;
        },
        // 设置离线消息id
        setOnLineMessageIds(state,onLineMessageIds){
            if(onLineMessageIds == 'delete'){
                state.onLineMessageIds = ''
            }else{
                if(state.onLineMessageIds == ''){
                    let array = []
                    array[0] = onLineMessageIds
                    state.onLineMessageIds = array
                    return
                }
                state.onLineMessageIds = [...state.onLineMessageIds, onLineMessageIds];
            }
        },
        // 设置页面显示id
        setOnLineIds(state,onLineIds){
            if(onLineIds == 'delete'){
                state.onLineIds = ''
            }else{
                if(state.onLineIds == ''){
                    let array = []
                    array[0] = onLineIds
                    state.onLineIds = array
                    return
                }
                state.onLineIds = [...state.onLineIds,onLineIds];
            }
        },
    },
    // 响应组件
    actions: {
        socket({ commit, state, dispatch },{sockeUrl, onErrorEvent, onSucceedEvent, onUserInfo, router}){
            if(sockeUrl){
                commit('setProtectThread',false)
                // console.log(sockeUrl, onErrorEvent, onSucceedEvent, onUserInfo)
                commit('setSocketUrl',sockeUrl)
                commit('setOnErrorEventFun',onErrorEvent)
                commit('setOnSucceedEventFun',onSucceedEvent)
                commit('setUserInfos',onUserInfo)
                commit('setRouter', router);
                commit('setChatList',JSON.parse(localStorage.getItem(`chatList_${state.userInfo.id}`)) || [])
                // console.log(state.websocketUrl)
                // console.log(onUserInfo)
                //判断是否有websocet对象，有的话关闭
                if (state.socketTask && typeof state.socketTask.close === 'function') {
                    state.socketTask.close();
                    commit('setSocketTask',null)
                }
                //判断是否有心跳定时器，有的话清除
                if (state.heartbeatInterval) {
                    // console.log('clear heatbeat interval...1');
                    clearInterval(state.heartbeatInterval); //清除心跳定时器
                    commit('setHeartbeatInterval',null)
                }
                if(state.heartbeatInterval2 != ''){
                    clearInterval(state.heartbeatInterval2);
                    commit('setHeartbeatInterval2','')
                }
                // 创建ws实列
                if(!navigator.onLine){
                    commit('setProtectThread',true)
                    // console.log('不在线')
                    return;
                }
                commit('setSocketTask',new WebSocket(state.websocketUrl))
                // console.log('clear heatbeat interval...2',state.websocketUrl);
                state.socketTask.onopen = (event)=>{
                    // console.log("我打开啦")
                    commit('setIsSocketOpened',true)
                    //判断是否有心跳定时器，有的话清除
                    if (state.heartbeatInterval) {
                        // console.log('clear heatbeat interval...2');
                        clearInterval(state.heartbeatInterval); //清除心跳定时器
                        commit('setHeartbeatInterval',null)
                    }
                    if(state.heartbeatInterval2 != ''){
                        clearInterval(state.heartbeatInterval2);
                        commit('setHeartbeatInterval2','')
                    }
                    //连接服务器
                    // dispatch("sendMsg",socketObj.serverConnection({senderId:state.userInfo.id,token:localStorage.getItem('token')}))
                    // console.log(state.userInfo)
                    state.socketTask.send(socketObj.serverConnection({senderId:state.userInfo.id,token:localStorage.getItem('token')}))
                    commit('setProtectThread', false);
                    commit('setHeartbeatInterval2',setInterval(()=>{
                        if(!state.onlines){
                            return
                        }
                        const names = state.chatList.map(obj => obj.senderId).join(',');
                        // console.log(names);
                        post('/im/user/findIdOnlineStatus',{ids: names}).then((res)=>{
                            // console.log(res.list);
                            let newData = state.chatList.map(obj => {
                                return { ...obj, isOnline: 0 }; // 修改 field 字段的值为 NewValue
                            });
                            if(newData.length > 0 && res.list.length > 0){
                                res.list.forEach((item,index)=>{
                                    newData.forEach((obj)=>{
                                        if(obj.senderId == item){
                                            obj.isOnline = 1
                                        }
                                    })
                                })
                            }
                            commit('setChatList',newData);
                            localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(newData))
                        })
                    },1000 * 15))
                    //重新设置心跳计数器
                    commit('setHeartbeatInterval',setInterval(() => {
                        let senderId = state.userInfo.id
                        let token = localStorage.getItem('token');
                        // 发送用户是否在线申请
                        // if(state.onlines){
                        //     dispatch('isOnLine')
                        // }
                        if (senderId && token) {
                            let message = {
                                senderId: senderId,
                                token: token
                            }
                            // console.log(socketObj.serverConnection(message))
                            if (state.socketTask.readyState === WebSocket.CLOSED || state.socketTask.readyState === WebSocket.CLOSING) {
                                // state.onErrorEventFun("掉线啦");
                                if(JSON.stringify(state.unChat) != '{}'){
                                    state.onReceiveEventFun({...state.unChat,state:3})
                                }
                                commit('SetOnlines',false)
                                commit("setIsNetworkError", true);
                                dispatch('stop')
                            }
                            state.socketTask.send(socketObj.heartBeat(message))
                        } else {
                            // alert('请先登录')
                            dispatch('stop')
                        }
                    }, 1000 * 15)) // 10秒发送一次心跳


                    setTimeout(() => {
                        commit("setOnLineMessageIds", "delete")
                        commit("setOnLineIds", "delete")
                        // 延迟后执行的代码
                        get(`/im/friendmessage/findOfflineList?pageNum=1&pageSize=10`).then((res)=>{
                            // console.log(res.page,'0000000000000000000000000')
                            let array = res.page.list
                            for (const key in array) {
                                commit("setOnLineMessageIds",array[key].messageId)
                                if(array[key].messageType != messageType.MSGSIGNED){
                                    dispatch('offlineDataLoad',array[key])
                                }else{
                                    if(array[key].senderUserId == state.chatUserInfo.senderId){
                                        // commit("setChatListss",array[key].messageContent)
                                        commit("setOnLineIds",array[key].messageContent)
                                    }else{
                                        let idsArray = array[key].messageContent.split(',');
                                        let objs = CircularJSON.parse(localStorage.getItem(`msgList_${state.userInfo.id}_${array[key].senderUserId}`))
                                        let arrays = objs.msgList;
                                        idsArray.forEach((id)=>{
                                            let foundObject = arrays.find(obj => obj.messageId == id);
                                            // console.log(foundObject,'456')
                                            if (foundObject) {
                                                foundObject.isSend = 2;
                                            }
                                        })
                                        objs.msgList = arrays;
                                        localStorage.setItem(`msgList_${state.userInfo.id}_${array[key].senderUserId}`,CircularJSON.stringify(objs))
                                    }
                                }
                            }
                            // const result = array.map(obj => obj.messageId).join(',');
                            if(res.page.pages <= 1){
                                return
                            }
                            // post(`/im/friendmessage/offlineMsgReceived`,{ids: result}).then((res)=>{
                            //     // console.log(res)
                            // })
                            dispatch('offlineData',res.page.pages)
                        })
                    }, 4000); // 延迟 3000 毫秒（3 秒）
                }
                //监听错误
                state.socketTask.onError = (err) => {
                    commit('setIsSocketOpened',false)
                    // console.log('3-->WebSocket连接失败,err-->', err);

                    if (state.heartbeatInterval) {
                        // console.log('clear heatbeat interval...3');
                        clearInterval(state.heartbeatInterval); //清除心跳定时器
                        commit('setHeartbeatInterval',null)
                    }
                    if(state.heartbeatInterval2 != ''){
                        clearInterval(state.heartbeatInterval2);
                        commit('setHeartbeatInterval2','')
                    }
                    if (state.socketTask) {
                        state.socketTask.close()
                        commit('setSocketTask',null)
                    }
                }
                // 监听关闭
                state.socketTask.onClose = (e) => {
                    commit('setIsSocketOpened',false)
                    // console.log('4-->WebSocket连接关闭！');

                    if (state.heartbeatInterval) {
                        // console.log('clear heatbeat interval...4');
                        clearInterval(state.heartbeatInterval); //清除心跳定时器
                        commit('setHeartbeatInterval',null)
                    }
                    if(state.heartbeatInterval2 != ''){
                        clearInterval(state.heartbeatInterval2);
                        commit('setHeartbeatInterval2','')
                    }
                    if (state.socketTask && typeof state.socketTask.close === 'function') {
                        state.socketTask.close();
                        commit('setSocketTask', null)
                    }
                    // if (!isManualClose) {
                    //     if (reconnectCount >= 1) {
                    //         reconnectCount--
                    //         reconnect(websocketUrl, onErrorEvent)
                    //     }else{
                    //         uni.showToast({
                    //             icon: 'none',
                    //             title: 'IM服务器连接失败...',
                    //             duration: 2000
                    //         });
                    //     }
                    // }
                }
            }
            // 监听收到信息
            state.socketTask.addEventListener('message',function(res){
                let serverData = res.data
                serverData = JSON.parse(serverData)
                dispatch('receiveMessages',serverData)
                // dispatch('setChatListsss',serverData)
                // console.log(serverData,"-----------------------------")
            }) 
            // console.log("socketTask object -->", state.socketTask)
        },
        //发送请求
        sendMsg({ commit, state },msgobj){
            state.socketTask.send(msgobj)
        },
        // 关闭websocket【必须在实例销毁之前关闭,否则会是underfined错误】beforeDestroy() {websocetObj.stop();}
        stop({ commit, state, dispatch }){
            if (state.heartbeatInterval) {
                // console.log('clear heatbeat interval...6');
                clearInterval(state.heartbeatInterval); //清除心跳定时器
                commit('setHeartbeatInterval',null)
            }
            if(state.heartbeatInterval2 != ''){
                clearInterval(state.heartbeatInterval2);
                commit('setHeartbeatInterval2','')
            }
            if (state.socketTask && typeof state.socketTask.close === 'function') {
                state.socketTask.close();
                commit('setSocketTask', null)
            }
            commit('setIsSocketOpened', false)
            commit('setIsManualClose', true)
            if(state.loggedIn){
                return
            }
            commit('setProtectThread',true)
        },

        // 处理数据
        receiveMessages({ commit,dispatch,state },message,states=0){
            
            // 私聊消息
            // console.log("//",message)
            if(message.actionType == actionType.FRIENDMSG){
                if(message.message.messageType == messageType.TEXT || message.message.messageType == messageType.IMAGE){
                    let chatList = JSON.parse(localStorage.getItem(`chatList_${state.userInfo.id}`))
                    let isFind = false;
                    let list = []
                    let IMages = ''
                    if(message.message.messageType == messageType.IMAGE){
                        IMages = `[图片]`
                    }else if(message.message.messageType == messageType.TEXT){
                        IMages = message.message.message
                    }
                    if (chatList) {
                        // console.log('我走了')
                        list = chatList
                        // onceChat = []
                        let unReadNum = 0
                        for (let item of chatList) {
                            // console.log(item)
                            if (item.senderId == message.message.senderId) {
                                let i = chatList.findIndex(item => {
                                    return item.senderId === message.message.senderId;
                                })
                                dispatch('setChatListsss',message)
                                // 更新消息列表的阅读数量
                                // if (state == 1) {
                                //     // 如果在聊天里未读为零
                                //     item.unReadNums = 0;
                                // } else {
                                //     item.unReadNums++;
                                // }
                                // 更新消息列表的最新消息
                                // if (message.message.messageType == messageType.TEXT) {
                                    item.lastMessage = IMages
                                    // 更新消息列表最后一条消息的日期
                                    // item.lastMessageTime = message.message.createTime
                                // }
                                // 更新消息的昵称
                                item.nickName = item.nickName
                                // 已读未读
                                item.isSend = 1
                                // 更新消息的头像
                                item.headImage = item.headImage
                                // 更新消息列表最后一条消息的日期
                                item.lastMessageTime = message.message.createTime
                                // 更新消息列表未读数量
                                if(item.senderId != state.chatUserInfo.senderId){
                                    item.unReadNums++
                                }
                                item.messageId = message.message.messageId
                                item.messageType = message.message.messageType
                                // item.lastMessageTime_copy = message.message.createTime
                                // // 如果缓存有相关数据就添加消息内容
                                // var messageList = {
                                //     senderId: message.message.senderId,
                                //     receiverId: message.message.receiverId,
                                //     messageType: message.message.messageType,
                                //     message: message.message.message,
                                //     messageId: message.message.messageId,
                                //     messageTime: message.message.createTime,
                                //     readState: 1,
                                //     isMine: false
                                // }
                                // 先复制一份数据
                                let list_copy = item
                                list.splice(i, 1)
                                // 把消息放在最前面
                                list.unshift(list_copy)
                                // that.chatList = uni.getStorageSync('chatList')
                                localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                                commit('setChatList',list)
                                // console.log(state.chatList,"-----------------------------??????")
                                isFind = true;
                                break;
                            }
                        }
                    }

                    if (!isFind) {
                        // console.log(3213131)
                        // 更新消息列表的阅读数量
                        isFind = true
                        // if (state == 1) {
                        //     // 如果在聊天里未读为零
                        //     unReadNum = 0;
                        // } else {
                        //     unReadNum = 1;
                        // }
                        // 申请头像和昵称
                        get(`/im/user/get`,{id: message.message.senderId}).then((res)=>{
                            let chatList = {
                                senderId: message.message.senderId,
                                nickName: res.user.userNickname,
                                headImage: res.user.userHeader,
                                lastMessage: IMages,
                                messageType: message.message.messageType,
                                lastMessageTime: message.message.createTime,
                                unReadNums: 1,
                                isOnline: 1,
                            }
                            // console.log(this.userInfo, res.user)
                            // 最新消息放在最上面
                            list.unshift(chatList)
                            // console.log(state.userInfo,'cbdsiuhkdcoslncl')
                            localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                            let objs = {
                                isSend: 1,
                                senderId: res.user.id,
                                createTime: message.message.createTime,
                                messageContent: message.message.message,
                                messageId: message.message.messageId,
                                messageType: message.message.messageType
                            }
                            let obj = {
                                receiver: {
                                    headImage: res.user.userHeader,
                                    nickName: res.user.userNickname,
                                    senderId: res.user.id,
                                },
                                msgList: [objs]
                            }
                            // delete obj.chatUserInfo.mppRoleList
                            localStorage.setItem(`msgList_${state.userInfo.id}_${message.message.senderId}`,CircularJSON.stringify(obj))
                            // console.log("到了")
                            commit('setChatList',list)
                        })
                        
                        // if (state == 2) {
                        //     callback && callback(list, message.message.senderId)
                        // }
        
                    }
                    console.log('签收成功消息')
                }
                // 消息已读
                if(message.message.messageType == messageType.MSGSIGNED){
                    if(state.chatUserInfo.senderId == message.message.senderId){
                        commit('setChatListss',message.message.message)
                    }
                }
            }
            // 测试起点
            if(message.actionType == actionType.RESPONSEMSG){
                if(message.message.messageType == messageType.CONNECTED){
                    console.log("服务器连接成功");
                    commit('setIsLoggedIn',false);
                    commit('setIsNetworkError',false);
                }
                if(message.message.messageType == messageType.SENDSUCCESS){
                    // console.log("消息发送成功，推进");
                    // 加一个方法用来将列表修改
                    commit('setChatListssMove',state.unChat);
                    commit('setMute', false);
                    // 测试起点
                    if(JSON.stringify(state.unChat) == "{}"){
                        
                    }else{
                        state.onReceiveEventFun({...state.unChat,state:1})
                    }
                    // 测试终点
                    // commit('setChatListss',state.unChat); // 暂时屏蔽
                    commit('setUnChat',{});
                }
                if(message.message.messageType == messageType.CANNOTSPEAK){
                    console.log("被禁言");
                    if(JSON.stringify(state.unChat) == "{}"){
                        
                    }else{
                        state.onReceiveEventFun({...state.unChat,state:3})
                    }
                    commit('setUnChat',{});
                    commit('setMute', true);
                    state.onSucceedEventFun(message.message.message);
                }
                if(message.message.messageType == messageType.BREAKOFF){
                    console.log("其他地方登录");
                    commit('setIsLoggedIn', true);
                    if(JSON.stringify(state.unChat) == "{}"){
                        
                    }else{
                        state.onReceiveEventFun({...state.unChat,state:3})
                    }
                    commit('setUnChat',{});
                    // localStorage.removeItem('token');
                    // state.router.push('/login')
                    dispatch('stop');
                    state.onSucceedEventFun(message.message.message);
                }
            }
            // 测试终点
        },
        // 专门处理搜索好友到列表
        setChatListsss({state,commit,dispatch},message){
            if(state.chatUserInfo.senderId == message.message.receiverId){
                let localItem = CircularJSON.parse(localStorage.getItem(`msgList_${state.userInfo.id}_${message.message.receiverId}`))
                let keys = JSON.parse(localStorage.getItem(`sender`))
                keys = {
                    senderId: keys.senderId,
                    isSend: 0,
                    messageContent: message.message.message,
                    messageId: message.message.messageId,
                    messageType: message.message.messageType,
                    createTime: new Date().getTime(),
                }
                let list = JSON.parse(localStorage.getItem(`chatList_${state.userInfo.id}`));
                for (const key in state.chatList) {
                    if(state.chatList[key].senderId == message.message.receiverId){
                        let messages = ''
                        if(message.message.messageType == messageType.TEXT){
                            messages = message.message.message
                        }else if(message.message.messageType == messageType.IMAGE){
                            messages = '[图片]'
                        }
                        // 填写信息
                        let obj = {
                            headImage: state.chatList[key].headImage,
                            lastMessage: messages,
                            lastMessageTime: new Date().getTime(),
                            messageId: message.message.messageId,
                            messageType: message.message.messageType,
                            nickName: state.chatList[key].nickName,
                            senderId: state.chatList[key].senderId,
                            unReadNums: state.chatList[key].unReadNums,
                            isOnline: state.chatList[key].isOnline
                        }
                        // 先复制一份数据
                        let list_copy = state.chatList[key]
                        list.splice(key, 1)
                        // 把消息放在最前面
                        list.unshift(obj)
                        localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                        commit('setChatList',list)
                        break;
                    }
                }
                localItem.msgList.push(keys)
                localStorage.setItem(`msgList_${state.userInfo.id}_${message.message.receiverId}`,CircularJSON.stringify(localItem))
                commit('setUnChat',keys)
                // 测试
                commit('setChatListss',keys)
            }else if(state.chatUserInfo.senderId == message.message.senderId){
                let localItem = CircularJSON.parse(localStorage.getItem(`msgList_${state.userInfo.id}_${message.message.senderId}`))
                let keys = localItem.receiver
                keys = {
                    senderId: keys.senderId,
                    isSend: 1,
                    messageContent: message.message.message,
                    messageId: message.message.messageId,
                    messageType: message.message.messageType,
                    createTime: message.message.createTime,
                }
                localItem.msgList.push(keys)
                localStorage.setItem(`msgList_${state.userInfo.id}_${message.message.senderId}`,CircularJSON.stringify(localItem))
                commit('setChatListss',keys)
            }else{
                let localItem = CircularJSON.parse(localStorage.getItem(`msgList_${state.userInfo.id}_${message.message.senderId}`))
                let keys = localItem.receiver
                keys = {
                    senderId: keys.senderId,
                    isSend: 1,
                    messageContent: message.message.message,
                    messageId: message.message.messageId,
                    messageType: message.message.messageType,
                    createTime: message.message.createTime,
                }
                localItem.msgList.push(keys)
                localStorage.setItem(`msgList_${state.userInfo.id}_${message.message.senderId}`,CircularJSON.stringify(localItem))
            }
        },
        setChatListsssOld({state,commit,dispatch},message){
            // console.log("看到我没",message)
            // console.log(message.actionType == actionType.FRIENDMSG)
            if(message.actionType == actionType.FRIENDMSG){
                // console.log(state.chatUserInfo)
                // console.log(state.userInfo)
                // console.log(message,'好友信息')
                if(message.message.messageType == messageType.TEXT || message.message.messageType == messageType.IMAGE){
                    let messageContent = message.message.message
                    // console.log(message,"进入消息判断")
                    if(message.message.messageType == messageType.TEXT){
                        messageContent = message.message.message
                    }else if(message.message.messageType == messageType.IMAGE){
                        messageContent = message.message.message
                    }
                    // 寻找他的key和队友
                    let localItem = CircularJSON.parse(localStorage.getItem(`msgList_${message.message.senderId}`))
                    let keys = localItem[message.message.senderId]
                    // keys.createTime = message.message.createTime
                    keys = {
                        ...keys,
                        messageContent: messageContent,
                        messageId: message.message.messageId,
                        messageType: message.message.messageType,
                        createTime: message.message.createTime,
                    }
                    if(state.chatUserInfo.senderId == message.message.senderId){
                        // let obj = {
                        //     createTime: message.message.createTime,
                        //     messageContent: messageContent,
                        //     messageId: message.message.messageId,
                        //     messageType: message.message.messageType,
                        //     isOffline: 0, // 正在发送， 1已读 0未读
                        //     sender:{
                        //         id: state.chatUserInfo.senderId,
                        //         userHeader: state.chatUserInfo.headImage,
                        //         userNickname: state.chatUserInfo.nickName
                        //     },
                        //     receiver:{...state.userInfo}
                        // }
                        // commit('setChatListss',obj)
                        // keys.createTime = message.message.createTime
                        localItem.msgList.push(keys)
                        // console.log(keys,'????????')
                        localStorage.setItem(`msgList_${message.message.senderId}`,CircularJSON.stringify(localItem))
                        commit('setChatListss',keys)
                    }else if(state.chatUserInfo.senderId == message.message.receiverId){
                        // let obj = {
                        //     createTime: new Date().getTime(),
                        //     messageContent: message.message.message,
                        //     messageId: message.message.messageId,
                        //     messageType: message.message.messageType,
                        //     isOffline: 0, // 正在发送， 1已读 0未读
                        //     receiver:{
                        //         id: state.chatUserInfo.senderId,
                        //         userHeader: state.chatUserInfo.headImage,
                        //         userNickname: state.chatUserInfo.nickName
                        //     },
                        //     sender:{...state.userInfo}
                        // }
                        // commit('setUnChat',obj)// 需要转移缓存转移
                        keys.createTime = new Date().getTime()
                        localStorageItem.msgList.push(localStorageItem)
                        localStorage.setItem(`msgList_${message.message.senderId}`,CircularJSON.stringify(localStorageItem))
                        commit('setUnChat',keys)
                    }else{
                        // keys.createTime = message.message.createTime
                        keys.senderId = message.message.senderId
                        localStorageItem.msgList.push(localStorageItem)
                        localStorage.setItem(`msgList_${message.message.senderId}`,CircularJSON.stringify(localStorageItem))
                    }
                }
            }
            if(message.actionType == actionType.RESPONSEMSG){
                if(message.message.messageType == messageType.CONNECTED){
                    // console.log("服务器连接成功");
                    commit('setIsLoggedIn',false);
                    commit('setIsNetworkError',false);
                }
                if(message.message.messageType == messageType.SENDSUCCESS){
                    // console.log("消息发送成功，推进");
                    // 加一个方法用来将列表修改
                    commit('setChatListssMove',state.unChat);
                    commit('setMute', false);
                    commit('setChatListss',state.unChat);
                    commit('setUnChat',{});
                }
                if(message.message.messageType == messageType.CANNOTSPEAK){
                    // console.log("被禁言");
                    commit('setUnChat',{});
                    commit('setMute', true);
                    // state.onSucceedEventFun(message.message.message);
                }
                if(message.message.messageType == messageType.BREAKOFF){
                    // console.log("其他地方登录");
                    commit('setIsLoggedIn', true);
                    // localStorage.removeItem('token');
                    // state.router.push('/login')
                    dispatch('stop');
                    // state.onSucceedEventFun(message.message.message);
                }
            }
        },
        addFriend({state,commit,dispatch},item){
            // 判断是不是已经存在用户列表
            console.log(item,'开始添加啦');
            let frist = false;
            let list = JSON.parse(localStorage.getItem(`chatList_${state.userInfo.id}`)) || [];
            for (const key in state.chatList) {
                if(state.chatList[key].senderId == item.id){
                    // 先复制一份数据
                    let list_copy = state.chatList[key]
                    list.splice(key, 1)
                    // 把消息放在最前面
                    list.unshift(list_copy)
                    localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                    // that.chatList = uni.getStorageSync('chatList')
                    commit('setChatList',list)
                    commit('setChatUserInfo',list_copy)
                    frist = true
                    break;
                }
            }
            // 没有的话
            if(!frist){
                // 申请头像和昵称
                // get(`/im/user/get`,{id: item.myUser.id}).then((res)=>{
                    let chatList = {
                        senderId: item.id,
                        nickName: item.userNickname,
                        headImage: item.userHeader,
                        lastMessage: ' ',
                        messageType: 1,
                        messageId: '',
                        lastMessageTime: new Date().getTime(),
                        unReadNums: 0,
                        isOnline: item.isOnline
                    }
                    let obj = {
                        receiver: {
                            headImage: item.userHeader,
                            nickName: item.userNickname,
                            senderId: item.id,
                        },
                        msgList: []
                    }
                    // 最新消息放在最上面
                    list.unshift(chatList)
                    localStorage.setItem(`msgList_${state.userInfo.id}_${item.id}`,CircularJSON.stringify(obj))
                    localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                    commit('setChatList',list)
                    commit('setChatUserInfo',chatList)
                // })
            }
            // console.log(state.chatList)
        },
        // 用户是否在线
        isOnLine({state,commit,dispatch}){
            const names = state.chatList.map(obj => obj.senderId).join(',');
            // console.log(names);
            post('/im/user/findIdOnlineStatus',{ids: names}).then((res)=>{
                // console.log(res.list);
                let newData = state.chatList.map(obj => {
                    return { ...obj, isOnline: 0 }; // 修改 field 字段的值为 NewValue
                });
                if(newData.length > 0 && res.list.length > 0){
                    res.list.forEach((item,index)=>{
                        newData.forEach((obj)=>{
                            if(obj.senderId == item){
                                obj.isOnline = 1
                            }
                        })
                    })
                }
                commit('setChatList',newData);
                localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(newData))
            })
        },
        // 申请离线数据
        offlineData({state,commit,dispatch},pages){
            // console.log(pages,'怎么说？')
            for (let i = 2; i <= pages; i++) {
                get('/im/friendmessage/findOfflineList',{pageNum:i,pageSize:10}).then((res)=>{
                    // console.log(res.page,i,'1111111111111111111111');
                    let array = res.page.list
                    for (const key in array) {
                        commit("setOnLineMessageIds",array[key].messageId)
                        if(array[key].messageType != messageType.MSGSIGNED){
                            dispatch('offlineDataLoad',array[key])
                        }else{
                            if(array[key].senderUserId == state.chatUserInfo.senderId){
                                // commit("setChatListss",array[key].messageContent)
                                commit("setOnLineIds",array[key].messageContent)
                            }else{
                                let idsArray = array[key].messageContent.split(',');
                                let objs = CircularJSON.parse(localStorage.getItem(`msgList_${state.userInfo.id}_${array[key].senderUserId}`))
                                let arrays = objs.msgList;
                                idsArray.forEach((id)=>{
                                    let foundObject = arrays.find(obj => obj.messageId == id);
                                    // console.log(foundObject,'456')
                                    if (foundObject) {
                                        foundObject.isSend = 2;
                                    }
                                })
                                objs.msgList = arrays;
                                localStorage.setItem(`msgList_${state.userInfo.id}_${array[key].senderUserId}`,CircularJSON.stringify(objs))
                            }
                        }
                    }
                    if(i == pages){
                        if(state.onLineIds != ''){
                            commit("setChatListss", state.onLineIds.join(","))
                        }
                        if(state.onLineMessageIds != ''){
                            post(`/im/friendmessage/offlineMsgReceived`,{ids: state.onLineMessageIds.join(",")}).then((res)=>{
                                // console.log(res)
                            })
                        }
                    }
                    // const result = array.map(obj => obj.messageId).join(',');
                    // if(result == ''){
                    //     return
                    // }
                    // post(`/im/friendmessage/offlineMsgReceived`,{ids: result}).then((res)=>{
                    //     // console.log(res)
                    // })
                })
            }
        },
        // 离线数据载入逻辑部分
        offlineDataLoad({state,commit,dispatch},item){
            console.log(item,'离线数据载入逻辑部分');
            let frist = false;
            let IMages = ''
            if(item.messageType == messageType.IMAGE){
                IMages = `[图片]`
            }else if(item.messageType == messageType.TEXT){
                IMages = item.messageContent
            }
            let list = JSON.parse(localStorage.getItem(`chatList_${state.userInfo.id}`)) || [];
            for (const key in state.chatList) {
                if(state.chatList[key].senderId == item.senderUserId){
                    // console.log(state.chatList[key].unReadNums++)
                    // 先复制一份数据
                    let list_copy = {
                        headImage: state.chatList[key].headImage,
                        isOnline: state.chatList[key].isOnline,
                        lastMessage: IMages,
                        lastMessageTime: item.createTime,
                        messageId: item.messageId,
                        messageType: item.messageType,
                        nickName: state.chatList[key].nickName,
                        unReadNums: item.senderUserId == state.chatUserInfo.senderId ? 0 : ++state.chatList[key].unReadNums,
                        senderId: item.senderUserId,
                    }
                    
                    list.splice(key, 1)
                    // 把消息放在最前面
                    list.unshift(list_copy)
                    localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                    // 将这条信息存入缓存中
                    let obj = {
                        createTime: item.createTime,
                        isSend: 1,
                        messageContent: item.messageContent,
                        messageId: item.messageId,
                        messageType: item.messageType,
                        senderId: item.senderUserId,
                    }
                    // 拿出对应缓存
                    let objs = CircularJSON.parse(localStorage.getItem(`msgList_${item.receiverUserId}_${item.senderUserId}`));
                    // console.log(objs,'那肯定要有啊',JSON.stringify(`msgList_${item.receiverUserId}_${item.senderUserId}`))
                    objs.msgList.push(obj)
                    localStorage.setItem(`msgList_${item.receiverUserId}_${item.senderUserId}`, CircularJSON.stringify(objs))
                    commit('setChatList',list)
                    console.log(obj.senderId == state.chatUserInfo.senderId)
                    if(obj.senderId == state.chatUserInfo.senderId){
                        commit('setChatListss',obj)
                    }
                    frist = true
                    break;
                }
            }
            // 没有的话
            if(!frist){
                if(!item.sender){
                    return;
                }
                // 申请头像和昵称
                // get(`/im/user/get`,{id: item.myUser.id}).then((res)=>{
                    let chatList = {
                        senderId: item.sender.id,
                        nickName: item.sender.userNickname,
                        headImage: item.sender.userHeader,
                        lastMessage: item.messageContent,
                        messageType: item.messageType,
                        messageId: item.messageId,
                        lastMessageTime: item.createTime,
                        unReadNums: 1,
                        isOnline: item.isOnline
                    }
                    let objs = {
                        isSend: 1,
                        senderId: item.sender.id,
                        createTime: item.createTime,
                        messageContent: item.messageContent,
                        messageId: item.messageId,
                        messageType: item.messageType
                    }
                    let obj = {
                        receiver: {
                            headImage: item.sender.userHeader,
                            nickName: item.sender.userNickname,
                            senderId: item.sender.id,
                        },
                        msgList: [objs]
                    }
                    // 最新消息放在最上面
                    list.unshift(chatList)
                    localStorage.setItem(`msgList_${state.userInfo.id}_${item.sender.id}`,CircularJSON.stringify(obj))
                    localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                    commit('setChatList',list)
                // })
            }
        },
        notOnLine({state,commit,dispatch}, item){
            // console.log(item,'不在线了都还烦我');
            let IMages = '';
            if(item.messageType == messageType.IMAGE){
                IMages = `[图片]`
            }else if(item.messageType == messageType.TEXT){
                IMages = item.messageContent
            }
            let list = JSON.parse(localStorage.getItem(`chatList_${state.userInfo.id}`)) || [];
            for (const key in state.chatList) {
                // console.log("????????",state.chatList[key].senderId,item.senderId)
                if(state.chatList[key].senderId == item.receiverId){
                    // console.log(state.chatList[key].unReadNums++)
                    // 先复制一份数据
                    let list_copy = {
                        headImage: state.chatList[key].headImage,
                        isOnline: state.chatList[key].isOnline,
                        lastMessage: IMages,
                        lastMessageTime: item.createTime,
                        messageId: item.messageId,
                        messageType: item.messageType,
                        nickName: state.chatList[key].nickName,
                        unReadNums: state.chatList[key].unReadNums,
                        senderId: item.receiverId,
                    }
                    let obj = {
                        createTime: item.createTime,
                        isSend: item.isSend,
                        messageContent: item.messageContent,
                        messageId: item.messageId,
                        messageType: item.messageType,
                        senderId: item.senderId,
                    }
                    list.splice(key, 1)
                    list.unshift(list_copy)
                    let objs = CircularJSON.parse(localStorage.getItem(`msgList_${item.senderId}_${item.receiverId}`));
                    if(item.isSend == 3){
                        objs.msgList.push(obj)
                        localStorage.setItem(`msgList_${item.senderId}_${item.receiverId}`, CircularJSON.stringify(objs))
                    }else if(item.isSend == 0){
                        let array = JSON.parse(JSON.stringify(objs.msgList))
                        for (const key in array) {
                            if(array[key].messageId == item.messageId){
                                let obj1 = array[key]
                                obj1.createTime = item.createTime
                                objs.msgList.splice(key, 1)
                                objs.msgList.push(obj1)
                                localStorage.setItem(`msgList_${item.senderId}_${item.receiverId}`, CircularJSON.stringify(objs))
                                break;
                            }
                        }
                    }
                    localStorage.setItem(`chatList_${state.userInfo.id}`, JSON.stringify(list))
                    commit('setChatList',list)
                    if(item.isSend == 3){
                        commit('setChatListss',obj)
                    }else if(item.isSend == 0){
                        commit('setUnChat',obj);
                        state.onReceiveEventFun({...obj,state:1,cc: item.createTime})
                    }
                    return;
                }
            }
        },
    }
}